import { apiSlice } from '../apiSlice';
import { API_CORE_URL } from '../../constants/env';
import { API_TAGS } from '../../constants/api';
import { MESSAGES } from './jobsMessages';

export const jobsSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchJobs: builder.query({
      query: ({ orgId, urlParams }) => ({
        url: `organizations/${orgId}/jobs`,
        method: 'GET',
        API_URL: API_CORE_URL,
        params: {
          ...urlParams
        },
        errorMessage: {
          showMessage: true,
          messages: MESSAGES.FETCH_JOBS.ERROR
        }
      }),
      providesTags: (result, error, args) => {
        return [{ type: API_TAGS.JOBS, id: 'LIST' }];
      }
    }),
    cancelJob: builder.mutation({
      query: ({ orgId, id, successMessage = { showMessage: true } }) => ({
        url: `organizations/${orgId}/jobs/${id}/cancel`,
        method: 'POST',
        body: null,
        errorMessage: {
          showMessage: true,
          messages: MESSAGES.CANCEL_JOB.ERROR
        },
        successMessage: {
          ...successMessage,
          messages: MESSAGES.CANCEL_JOB.SUCCESS
        }
      }),
      invalidatesTags: (result, error, args) => {
        if (error) {
          return [];
        }
        return [
          { type: API_TAGS.JOBS, id: 'LIST' }
        ];
      }
    }),

    createJob: builder.mutation({
      query: ({ orgId, data, successMessage = { showMessage: false } }) => ({
        url: `organizations/${orgId}/jobs`,
        method: 'POST',
        body: data,
        errorMessage: {
          showMessage: true,
          messages: MESSAGES.CREATE_JOB.ERROR
        },
        successMessage: {
          ...successMessage,
          messages: MESSAGES.CREATE_JOB.SUCCESS
        }
      }),
      invalidatesTags: (result, error, args) => {
        if (error) {
          return [];
        }
        return [
          { type: API_TAGS.JOBS, id: 'LIST' }
        ];
      }
    }),
    createJobs: builder.mutation({
      query: ({ orgId, data, successMessage = { showMessage: false } }) => ({
        url: `organizations/${orgId}/jobs/bulk-create`,
        method: 'POST',
        body: data,
        errorMessage: {
          showMessage: true,
          messages: MESSAGES.CREATE_JOBS.ERROR
        },
        successMessage: {
          ...successMessage,
          messages: MESSAGES.CREATE_JOBS.SUCCESS
        }
      }),
      transformResponse: (response, meta, arg) => {
        return arg.data;
      },
      invalidatesTags: (result, error, args) => {
        if (error) {
          return [];
        }
        return [
          { type: API_TAGS.JOBS, id: 'LIST' }
        ];
      }
    })
  })
});
export const {
  useFetchJobsQuery,
  useLazyFetchJobsQuery,
  useCancelJobMutation,
  useCreateJobMutation,
  useCreateJobsMutation
} = jobsSlice;

